import PermissionGuard from "@/components/PermissionGuard/PermissionGuard";
import React from "react";
import { Route } from "react-router-dom";
import MainLayout from "../../components/MainLayout/MainLayout";
import CheckoutLayout from "../../components/CheckoutLayout/CheckoutLayout";
import { AuthenticationGuard } from "@/components/AuthenticationGuard/AuthenticationGuard";
import ProductDirectoryPage from "@/modules/stochastic/features/ProductStore/components/ProductDirectoryPage/ProductDirectoryPage";
import ProductDetailPage from "@/modules/stochastic/features/ProductStore/components/ProductDetailPage/ProductDetailPage";
import ProductCheckoutPage from "@/modules/stochastic/features/ProductStore/components/ProductCheckout/ProductCheckoutPage";
import ProductOrderConfirmation from "@/modules/stochastic/features/ProductStore/components/ProductOrderConfirmation/ProductOrderConfirmation";

const ProductDirectoryLayout = () => <MainLayout section="product-directory" />;
const ProductDirectoryCheckoutLayout = () => <CheckoutLayout />;

const ProductDirectoryRoutes = (
  <>
    {/* Browsing — full app shell */}
    <Route
      element={<AuthenticationGuard component={ProductDirectoryLayout} />}
      path="/product-directory"
    >
      <Route
        element={
          <PermissionGuard requiredPermissions={["shop-products"]}>
            <ProductDirectoryPage />
          </PermissionGuard>
        }
        index
      />
      <Route
        element={
          <PermissionGuard requiredPermissions={["shop-products"]}>
            <ProductDetailPage />
          </PermissionGuard>
        }
        path=":id"
      />
    </Route>

    {/* Checkout — focused layout */}
    <Route
      element={
        <AuthenticationGuard component={ProductDirectoryCheckoutLayout} />
      }
      path="/product-directory"
    >
      <Route element={<ProductCheckoutPage />} path="checkout" />
      <Route
        element={<ProductOrderConfirmation />}
        path="orders/:uuid/confirmation"
      />
    </Route>
  </>
);

export default ProductDirectoryRoutes;
